export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOADING = "LOADING";
export const ME = "ME";
export const PERSONS = "PERSONS";
export const UNFOLLOW = "UNFOLLOW";
